module.exports = __webpack_public_path__ + "img/20191204171949934.9450eb47.jpg";